<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      elevate-on-scroll
      flat
      height="80"
      class="header-elegant"
    >
      <v-container class="d-flex align-center py-0">
        <!-- Logo -->
        <v-toolbar-title class="d-flex align-center">
          <div class="logo-wrapper">
            <div class="logo-container">
              <span class="logo-text primary--text font-weight-black">INNOVA A&G</span>
              <span class="logo-subtitle accent--text text-caption"
                >CONSULTORA INTEGRAL</span
              >
            </div>
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Navegación -->
        <div class="d-none d-md-flex align-center navigation-wrapper">
          <v-btn
            v-for="(item, index) in menuItems"
            :key="`nav-${index}`"
            text
            class="nav-btn"
            :to="item.path"
            active-class="active-nav"
            :ripple="false"
          >
            <v-icon small class="mr-1">{{ item.icon }}</v-icon>
            <span class="nav-text">{{ item.title }}</span>
          </v-btn>
        </div>

        <!-- Botón WhatsApp flotante -->
        <v-btn
          color="green darken-2"
          dark
          class="ml-4 whatsapp-fixed d-none d-md-flex"
          depressed
          large
          @click="openWhatsAppGeneral"
        >
          <v-icon left>mdi-whatsapp</v-icon>
          <span class="font-weight-bold">WhatsApp</span>
        </v-btn>

        <!-- Menú móvil -->
        <v-app-bar-nav-icon
          class="d-md-none mobile-menu-icon"
          @click="drawer = !drawer"
          :ripple="false"
        >
          <v-icon>mdi-menu</v-icon>
        </v-app-bar-nav-icon>
      </v-container>
    </v-app-bar>

    <!-- Drawer móvil -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      width="320"
      class="mobile-drawer"
    >
      <div class="drawer-header pa-4">
        <div class="d-flex align-center">
          <v-icon color="primary" large class="mr-3">mdi-briefcase</v-icon>
          <div>
            <h3 class="text-h5 font-weight-bold primary--text mb-0">INNOVA A&G</h3>
            <p class="text-caption accent--text mb-0">Consultora Integral</p>
          </div>
        </div>
        <v-btn icon @click="drawer = false" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>

      <v-list nav dense class="mobile-nav-list">
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="`mobile-${index}`"
          :to="item.path"
          @click="drawer = false"
          class="mobile-nav-item"
        >
          <v-list-item-icon class="mr-3">
            <v-icon :color="item.color" size="24">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium text-body-1">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <div class="drawer-footer pa-4">
        <v-btn color="green darken-2" block large depressed @click="openWhatsAppGeneral">
          <v-icon left>mdi-whatsapp</v-icon>
          Contactar por WhatsApp
        </v-btn>
      </div>
    </v-navigation-drawer>

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-background">
        <div class="hero-gradient"></div>
        <div class="hero-pattern"></div>
      </div>

      <v-container class="hero-container">
        <!-- Encabezado -->
        <v-row class="py-12">
          <v-col cols="12" class="text-center mb-8">
            <div class="quality-badge mb-4">
              <v-chip color="accent" dark class="quality-chip" label>
                <v-icon left>mdi-shield-check</v-icon>
                Soluciones Integrales Certificadas
              </v-chip>
            </div>

            <h1 class="hero-title mb-4">
              Transformación Digital & Consultoría
              <span class="highlight-text">Integral</span>
            </h1>

            <p class="hero-subtitle mb-6">
              Desde tecnología hasta asesoría contable: un partner estratégico para el
              crecimiento sostenible de tu empresa
            </p>
          </v-col>

          <!-- Carrusel Dinámico -->
          <v-col cols="12">
            <v-carousel
              v-model="carouselModel"
              cycle
              height="500"
              hide-delimiter-background
              :show-arrows="false"
              :interval="4000"
              class="services-carousel"
              :continuous="true"
            >
              <!-- Slide 1: Formación Tecnológica -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="primary" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-school</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Formación Tecnológica <span class="highlight">de Alto Nivel</span>
                    </h3>
                    <p class="carousel-description">
                      Capacitación práctica en Java, .NET, Python, IA, Cloud y tecnologías
                      emergentes.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-account-group</v-icon>
                        <span>+1000 Profesionales</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-certificate</v-icon>
                        <span>Certificaciones</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppFormacion"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        WhatsApp
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn"
                        large
                        @click="scrollToContact"
                        outlined
                      >
                        <v-icon left>mdi-email</v-icon>
                        Email
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>

              <!-- Slide 2: Outsourcing -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="accent" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-account-multiple-plus</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Outsourcing <span class="highlight">Especializado</span>
                    </h3>
                    <p class="carousel-description">
                      Proporcionamos profesionales calificados en TI, contabilidad,
                      administración y más.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-clock-fast</v-icon>
                        <span>24-48 horas</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-shield-check</v-icon>
                        <span>+95% Clientes</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppOutsourcing"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        WhatsApp
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn"
                        large
                        @click="scrollToContact"
                        outlined
                      >
                        <v-icon left>mdi-email</v-icon>
                        Email
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>

              <!-- Slide 3: Desarrollo de Software -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="success" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-code-braces</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Desarrollo <span class="highlight">a la Medida</span>
                    </h3>
                    <p class="carousel-description">
                      Soluciones tecnológicas robustas, escalables e innovadoras para tu
                      negocio.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-rocket-launch</v-icon>
                        <span>Ágil</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-security</v-icon>
                        <span>Seguro</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppDesarrollo"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        Cotizar por WhatsApp
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn"
                        large
                        @click="scrollToContact"
                        outlined
                      >
                        <v-icon left>mdi-email</v-icon>
                        Solicitar Demo
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>

              <!-- Slide 4: Soporte Técnico -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="warning" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-headset</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Soporte Técnico <span class="highlight">24/7</span>
                    </h3>
                    <p class="carousel-description">
                      Mantenimiento, monitoreo y asistencia técnica proactiva para tus
                      sistemas.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-clock-outline</v-icon>
                        <span>99.9%</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-check-all</v-icon>
                        <span>Inmediato</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppSoporte"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        Soporte Urgente
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn emergency-btn"
                        large
                        @click="openEmergencyModal"
                        outlined
                      >
                        <v-icon left>mdi-alert-circle</v-icon>
                        EMERGENCIA
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>

              <!-- Slide 5: Contact Center -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="error" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-phone-classic</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Contact Center <span class="highlight">Profesional</span>
                    </h3>
                    <p class="carousel-description">
                      Gestión y optimización de canales de comunicación omnichannel.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-chart-bell-curve</v-icon>
                        <span>+30%</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-shield-star</v-icon>
                        <span>ISO 9001</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppContactCenter"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        WhatsApp
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn"
                        large
                        @click="scrollToContact"
                        outlined
                      >
                        <v-icon left>mdi-email</v-icon>
                        Email
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>

              <!-- Slide 6: Asesoría Contable -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="purple" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-calculator</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Asesoría <span class="highlight">Contable</span>
                    </h3>
                    <p class="carousel-description">
                      Soluciones contables completas: declaraciones, auditorías,
                      planeación fiscal.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-file-document-check</v-icon>
                        <span>100%</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-chart-timeline</v-icon>
                        <span>Optimización</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppContable"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        WhatsApp
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn"
                        large
                        @click="scrollToContact"
                        outlined
                      >
                        <v-icon left>mdi-email</v-icon>
                        Email
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>

              <!-- Slide 7: Recursos Humanos -->
              <v-carousel-item>
                <v-card class="carousel-card" elevation="12" color="teal" dark>
                  <div class="carousel-card-content">
                    <div class="carousel-icon-wrapper">
                      <v-icon size="80">mdi-account-tie</v-icon>
                    </div>
                    <h3 class="carousel-title">
                      Recursos <span class="highlight">Humanos</span>
                    </h3>
                    <p class="carousel-description">
                      Gestión integral del talento: reclutamiento, capacitación,
                      desarrollo.
                    </p>
                    <div class="carousel-stats">
                      <div class="stat-item">
                        <v-icon color="white">mdi-briefcase-search</v-icon>
                        <span>Reclutamiento</span>
                      </div>
                      <div class="stat-item">
                        <v-icon color="white">mdi-chart-bar</v-icon>
                        <span>Desarrollo</span>
                      </div>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        color="white"
                        dark
                        class="carousel-btn whatsapp-btn"
                        large
                        @click="openWhatsAppRRHH"
                      >
                        <v-icon left>mdi-whatsapp</v-icon>
                        WhatsApp
                      </v-btn>
                      <v-btn
                        color="blue"
                        dark
                        class="carousel-btn"
                        large
                        @click="scrollToContact"
                        outlined
                      >
                        <v-icon left>mdi-email</v-icon>
                        Email
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-carousel-item>
            </v-carousel>

            <!-- Controles del carrusel -->
            <div class="carousel-controls mt-6">
              <div class="slide-indicators">
                <v-btn
                  v-for="n in carouselSlides"
                  :key="n"
                  icon
                  small
                  :color="carouselModel === n - 1 ? 'primary' : 'grey lighten-2'"
                  @click="goToSlide(n - 1)"
                  class="indicator-btn"
                >
                  <v-icon size="12">mdi-circle</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Indicadores y CTA -->
        <v-row class="mt-8">
          <v-col cols="12" class="text-center">
            <div class="trust-indicators">
              <div class="indicator-item">
                <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                <span>+10 años de experiencia</span>
              </div>
              <div class="indicator-item">
                <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                <span>+500 clientes satisfechos</span>
              </div>
              <div class="indicator-item">
                <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                <span>WhatsApp 24/7: +51 928 180 748</span>
              </div>
            </div>

            <div class="hero-actions mt-6">
              <v-btn
                color="green darken-2"
                dark
                x-large
                class="whatsapp-main-btn mr-3 mb-3"
                @click="openWhatsAppGeneral"
                depressed
              >
                <v-icon left>mdi-whatsapp</v-icon>
                Contactar por WhatsApp
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>

              <v-btn
                color="transparent"
                x-large
                outlined
                dark
                class="secondary-btn mb-3"
                @click="scrollToServices"
              >
                <v-icon left>mdi-view-grid</v-icon>
                Ver Todos los Servicios
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Todos los Servicios -->
    <section class="services-section py-12" id="services-section">
      <v-container>
        <div class="section-header text-center mb-10">
          <h2 class="section-title mb-4">Nuestros 7 Pilares de Servicio</h2>
          <p class="section-subtitle">
            Soluciones integrales que cubren todas las necesidades de tu empresa
          </p>
        </div>

        <v-row>
          <v-col
            v-for="(service, index) in services"
            :key="`service-${index}`"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="mb-6"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="service-card pa-4"
                :class="{ 'service-card-hover': hover }"
                :elevation="hover ? 8 : 4"
                @click="openWhatsAppService(service.id)"
              >
                <div class="service-icon-wrapper mb-4">
                  <div
                    class="service-icon-container"
                    :style="{ 'background-color': service.color + '15' }"
                  >
                    <v-icon size="48" :color="service.color">{{ service.icon }}</v-icon>
                  </div>
                </div>

                <h3 class="service-title mb-3">{{ service.title }}</h3>

                <p class="service-description mb-4">{{ service.description }}</p>

                <div class="service-features">
                  <div
                    v-for="(feature, idx) in service.features"
                    :key="idx"
                    class="service-feature"
                  >
                    <v-icon small color="success" class="mr-1">mdi-check</v-icon>
                    <span>{{ feature }}</span>
                  </div>
                </div>

                <v-btn
                  :color="service.color"
                  dark
                  class="service-btn mt-4"
                  block
                  depressed
                >
                  <v-icon left small>mdi-whatsapp</v-icon>
                  Contactar por WhatsApp
                </v-btn>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Ventajas Competitivas -->
    <section class="advantages-section py-12">
      <v-container>
        <div class="section-header text-center mb-10">
          <h2 class="section-title mb-4">¿Por qué elegirnos?</h2>
          <p class="section-subtitle">
            Ventajas que nos distinguen como tu partner estratégico
          </p>
        </div>

        <v-row>
          <v-col
            v-for="(advantage, index) in advantages"
            :key="`advantage-${index}`"
            cols="12"
            md="6"
            class="mb-6"
          >
            <v-card class="advantage-card pa-6" elevation="2">
              <div class="d-flex align-start">
                <v-avatar :color="advantage.color" size="60" class="mr-4">
                  <v-icon color="white" size="28">{{ advantage.icon }}</v-icon>
                </v-avatar>
                <div>
                  <h3 class="advantage-title mb-3">{{ advantage.title }}</h3>
                  <p class="advantage-description">{{ advantage.description }}</p>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Botón WhatsApp flotante móvil -->
    <v-btn
      color="green darken-2"
      dark
      fab
      large
      class="whatsapp-fab d-md-none"
      @click="openWhatsAppGeneral"
      fixed
      bottom
      right
    >
      <v-icon size="28">mdi-whatsapp</v-icon>
    </v-btn>

    <!-- Modal de Emergencia -->
    <v-dialog v-model="emergencyModal" max-width="500">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-alert-circle</v-icon>
          SOPORTE DE EMERGENCIA
        </v-card-title>

        <v-card-text class="pa-6">
          <p class="mb-4">
            <strong>¿Estás experimentando una emergencia técnica?</strong>
          </p>
          <p>
            Nuestro equipo de soporte está disponible 24/7 para ayudarte inmediatamente.
          </p>

          <div class="emergency-actions mt-6">
            <v-btn
              color="green darken-2"
              dark
              block
              large
              @click="openEmergencyWhatsApp"
              class="mb-3"
            >
              <v-icon left>mdi-whatsapp</v-icon>
              EMERGENCIA POR WHATSAPP
            </v-btn>

            <v-btn color="red" dark block large @click="callEmergency" class="mb-3">
              <v-icon left>mdi-phone</v-icon>
              LLAMAR DE EMERGENCIA
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="emergencyModal = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Cotización Rápida -->
    <v-dialog v-model="quickQuoteModal" max-width="500">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-chat-question</v-icon>
          Cotización Rápida
        </v-card-title>

        <v-card-text class="pa-6">
          <p class="mb-4">Complete sus datos para enviar por WhatsApp:</p>

          <v-text-field
            v-model="quickQuoteData.nombre"
            label="Nombre completo"
            outlined
            class="mb-4"
          ></v-text-field>

          <v-text-field
            v-model="quickQuoteData.telefono"
            label="Teléfono"
            outlined
            class="mb-4"
          ></v-text-field>

          <v-select
            v-model="quickQuoteData.servicio"
            :items="services.map((s) => s.title)"
            label="Servicio de interés"
            outlined
          ></v-select>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="quickQuoteModal = false">Cancelar</v-btn>
          <v-btn color="green darken-2" dark @click="sendQuickQuote">
            <v-icon left>mdi-whatsapp</v-icon>
            Enviar por WhatsApp
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" top>
      <div class="d-flex align-center">
        <v-icon class="mr-3">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.message }}</span>
      </div>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      drawer: false,
      carouselModel: 0,
      carouselSlides: 7,
      emergencyModal: false,
      quickQuoteModal: false,
      whatsappNumber: "51917915824",

      quickQuoteData: {
        nombre: "",
        telefono: "",
        servicio: "",
      },

      menuItems: [
        { title: "Inicio", path: "/", icon: "mdi-home", color: "primary" },
        {
          title: "Servicios",
          path: "/servicios",
          icon: "mdi-briefcase",
          color: "accent",
        },
        {
          title: "Nosotros",
          path: "/nosotros",
          icon: "mdi-account-group",
          color: "warning",
        },
        {
          title: "Soluciones",
          path: "/soluciones",
          icon: "mdi-puzzle",
          color: "success",
        },
        { title: "Contacto", path: "/contacto", icon: "mdi-headset", color: "error" },
      ],

      services: [
        {
          id: "formacion",
          icon: "mdi-school",
          title: "Formación Tecnológica",
          description: "Capacitación especializada en tecnologías emergentes",
          color: "primary",
          features: [
            "Certificaciones internacionales",
            "Metodología práctica",
            "Instructores expertos",
          ],
        },
        {
          id: "outsourcing",
          icon: "mdi-account-multiple-plus",
          title: "Outsourcing",
          description: "Talento especializado para tus proyectos",
          color: "accent",
          features: ["Integración rápida", "Garantía de calidad", "Flexibilidad total"],
        },
        {
          id: "desarrollo",
          icon: "mdi-code-braces",
          title: "Desarrollo de Software",
          description: "Soluciones tecnológicas a medida",
          color: "success",
          features: ["Desarrollo ágil", "Seguridad garantizada", "Soporte continuo"],
        },
        {
          id: "soporte",
          icon: "mdi-headset",
          title: "Soporte Técnico",
          description: "Asistencia especializada 24/7",
          color: "warning",
          features: [
            "Disponibilidad 99.9%",
            "Respuesta inmediata",
            "Monitoreo proactivo",
          ],
        },
        {
          id: "contact-center",
          icon: "mdi-phone-classic",
          title: "Contact Center",
          description: "Soluciones de comunicación omnichannel",
          color: "error",
          features: ["Experiencia cliente", "Certificación ISO", "BPO profesional"],
        },
        {
          id: "contable",
          icon: "mdi-calculator",
          title: "Asesoría Contable",
          description: "Consultoría fiscal y contable integral",
          color: "purple",
          features: ["Cumplimiento normativo", "Optimización fiscal", "Auditorías"],
        },
        {
          id: "rrhh",
          icon: "mdi-account-tie",
          title: "Recursos Humanos",
          description: "Gestión integral del talento",
          color: "teal",
          features: ["Reclutamiento", "Desarrollo organizacional", "Administración"],
        },
      ],

      advantages: [
        {
          icon: "mdi-shield-check",
          title: "Experiencia Comprobada",
          description:
            "+10 años transformando empresas con soluciones efectivas y resultados tangibles.",
          color: "primary",
        },
        {
          icon: "mdi-account-multiple",
          title: "Equipo Multidisciplinario",
          description:
            "Profesionales certificados en tecnología, contabilidad, administración y más.",
          color: "accent",
        },
        {
          icon: "mdi-update",
          title: "Innovación Constante",
          description:
            "Mantenemos nuestras soluciones actualizadas con las últimas tecnologías y mejores prácticas.",
          color: "success",
        },
      ],

      snackbar: {
        show: false,
        message: "",
        color: "",
        icon: "",
      },
    };
  },
  created() {
    this.autoAdvanceCarousel();
  },
  methods: {
    // Carrusel
    autoAdvanceCarousel() {
      setInterval(() => {
        this.carouselModel = (this.carouselModel + 1) % this.carouselSlides;
      }, 5000);
    },

    prevSlide() {
      this.carouselModel =
        this.carouselModel === 0 ? this.carouselSlides - 1 : this.carouselModel - 1;
    },

    nextSlide() {
      this.carouselModel = (this.carouselModel + 1) % this.carouselSlides;
    },

    goToSlide(index) {
      this.carouselModel = index;
    },

    // WhatsApp Methods
    openWhatsApp(message) {
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/${this.whatsappNumber}?text=${encodedMessage}`;
      window.open(whatsappUrl, "_blank");
    },

    openWhatsAppGeneral() {
      const message = `Hola, soy [Tu Nombre]. Necesito información sobre los servicios de Consultora Innova A&G:

• Empresa/Persona: 
• Servicio de interés: 
• Necesidad específica: 

Por favor contáctenme para coordinar una reunión.`;
      this.openWhatsApp(message);
    },

    openWhatsAppFormacion() {
      const message = `Hola, necesito información sobre formación tecnológica:

• Área de interés: 
• Nivel: (Básico/Intermedio/Avanzado)
• Cantidad de participantes: 
• Modalidad preferida: (Presencial/Virtual)

Gracias.`;
      this.openWhatsApp(message);
    },

    openWhatsAppOutsourcing() {
      const message = `Hola, necesito información sobre outsourcing de talento:

• Perfil requerido: 
• Cantidad de profesionales: 
• Duración del proyecto: 
• Habilidades específicas: 

Por favor contáctenme.`;
      this.openWhatsApp(message);
    },

    openWhatsAppDesarrollo() {
      const message = `Hola, necesito cotización para desarrollo de software:

• Tipo de proyecto: (Web/Móvil/Sistema)
• Funcionalidades principales: 
• Plazo estimado: 
• Presupuesto aproximado: 

Solicito reunión de análisis.`;
      this.openWhatsApp(message);
    },

    openWhatsAppSoporte() {
      const message = `URGENTE: Solicito soporte técnico:

• Sistema/plataforma: 
• Descripción del problema: 
• Nivel de urgencia: (Alta/Media/Baja)
• Contacto inmediato: 

Necesito asistencia lo antes posible.`;
      this.openWhatsApp(message);
    },

    openWhatsAppContactCenter() {
      const message = `Hola, necesito información sobre Contact Center:

• Canales requeridos: 
• Volumen de llamadas: 
• Horarios de operación: 
• Requisitos específicos: 

Gracias.`;
      this.openWhatsApp(message);
    },

    openWhatsAppContable() {
      const message = `Hola, necesito asesoría contable:

• Tipo de empresa: 
• Servicio requerido: (Declaraciones/Auditoría/Nóminas)
• Plazo: 
• Información adicional: 

Por favor contáctenme.`;
      this.openWhatsApp(message);
    },

    openWhatsAppRRHH() {
      const message = `Hola, necesito consultoría en RRHH:

• Servicio requerido: (Reclutamiento/Capacitación/Desarrollo)
• Cantidad de colaboradores: 
• Necesidad específica: 
• Plazo: 

Gracias.`;
      this.openWhatsApp(message);
    },

    openWhatsAppService(serviceId) {
      const service = this.services.find((s) => s.id === serviceId);
      if (service) {
        switch (serviceId) {
          case "formacion":
            this.openWhatsAppFormacion();
            break;
          case "outsourcing":
            this.openWhatsAppOutsourcing();
            break;
          case "desarrollo":
            this.openWhatsAppDesarrollo();
            break;
          case "soporte":
            this.openWhatsAppSoporte();
            break;
          case "contact-center":
            this.openWhatsAppContactCenter();
            break;
          case "contable":
            this.openWhatsAppContable();
            break;
          case "rrhh":
            this.openWhatsAppRRHH();
            break;
          default:
            this.openWhatsAppGeneral();
        }
      }
    },

    // Emergency Methods
    openEmergencyModal() {
      this.emergencyModal = true;
    },

    openEmergencyWhatsApp() {
      const message = `EMERGENCIA TÉCNICA - URGENTE:

• Sistema afectado: 
• Descripción de la emergencia: 
• Impacto en operaciones: 
• Contacto para coordinación: 

NECESITO ASISTENCIA INMEDIATA.`;
      this.openWhatsApp(message);
      this.emergencyModal = false;
    },

    callEmergency() {
      window.open(`tel:+51${this.whatsappNumber}`, "_self");
      this.emergencyModal = false;
    },

    // Quick Quote Methods
    openQuickQuote() {
      this.quickQuoteModal = true;
    },

    sendQuickQuote() {
      if (
        !this.quickQuoteData.nombre ||
        !this.quickQuoteData.telefono ||
        !this.quickQuoteData.servicio
      ) {
        this.showSnackbar("Por favor complete todos los campos", "warning", "mdi-alert");
        return;
      }

      const message = `SOLICITUD DE COTIZACIÓN:

• Nombre: ${this.quickQuoteData.nombre}
• Teléfono: ${this.quickQuoteData.telefono}
• Servicio: ${this.quickQuoteData.servicio}

Por favor contáctenme para enviar la cotización detallada.`;

      this.openWhatsApp(message);
      this.quickQuoteModal = false;
      this.quickQuoteData = { nombre: "", telefono: "", servicio: "" };
      this.showSnackbar("Mensaje enviado por WhatsApp", "success", "mdi-check-circle");
    },

    // Navigation
    scrollToService(serviceId) {
      this.openWhatsAppService(serviceId);
    },

    scrollToServices() {
      const element = document.getElementById("services-section");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    scrollToContact() {
      const element = document.getElementById("contact-form");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        this.openQuickQuote();
      }
      this.drawer = false;
    },

    // Notifications
    showSnackbar(message, color, icon) {
      this.snackbar = {
        show: true,
        message,
        color,
        icon,
      };
    },
  },
};
</script>

<style scoped>
/* WhatsApp Styles */
.whatsapp-fixed {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3) !important;
  transition: all 0.3s ease !important;
}

.whatsapp-fixed:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4) !important;
  background: linear-gradient(135deg, #25d366 0%, #075e54 100%) !important;
}

.whatsapp-fab {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%) !important;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3) !important;
  z-index: 1000;
  animation: pulse-whatsapp 2s infinite;
}

@keyframes pulse-whatsapp {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

.whatsapp-btn {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%) !important;
  border-radius: 12px !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3) !important;
}

.whatsapp-btn:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4) !important;
  background: linear-gradient(135deg, #25d366 0%, #075e54 100%) !important;
}

.whatsapp-main-btn {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%) !important;
  border-radius: 12px !important;
  padding: 0 32px !important;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.3) !important;
}

.whatsapp-main-btn:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 12px 30px rgba(37, 211, 102, 0.4) !important;
}

.emergency-btn {
  border: 2px solid #ff5252 !important;
  color: #ff5252 !important;
  font-weight: 700 !important;
  animation: pulse-emergency 1.5s infinite;
}

@keyframes pulse-emergency {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Carrusel Styles */
.services-carousel {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.carousel-card {
  height: 100%;
  border-radius: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s ease;
}

.carousel-card:hover {
  transform: scale(1.01);
}

.carousel-card-content {
  text-align: center;
  padding: 60px 40px;
  max-width: 800px;
  margin: 0 auto;
}

.carousel-icon-wrapper {
  margin-bottom: 30px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.carousel-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.2;
}

.carousel-title .highlight {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 700;
}

.carousel-description {
  font-size: 1.25rem;
  line-height: 1.6;
  margin-bottom: 40px;
  opacity: 0.95;
}

.carousel-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1rem;
  opacity: 0.95;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.carousel-btn {
  border-radius: 12px !important;
  padding: 16px 24px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: all 0.3s ease !important;
  min-width: 150px;
}

.carousel-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.slide-indicators {
  display: flex;
  gap: 12px;
}

.indicator-btn {
  transition: all 0.3s ease;
}

.indicator-btn:hover {
  transform: scale(1.2);
}

/* Hero Section */
.hero-section {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
  min-height: 85vh;
  display: flex;
  align-items: center;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.hero-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 70% 30%,
      rgba(23, 162, 184, 0.2) 0%,
      transparent 50%
    ),
    radial-gradient(circle at 30% 70%, rgba(0, 86, 179, 0.15) 0%, transparent 50%);
}

.hero-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  color: white;
  margin-bottom: 1.5rem;
}

.highlight-text {
  background: linear-gradient(135deg, #25d366, #128c7e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  display: inline-block;
}

.highlight-text::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #25d366, #128c7e);
  border-radius: 2px;
}

.hero-subtitle {
  font-size: 1.25rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  max-width: 800px;
  margin: 0 auto;
}

.quality-badge {
  display: inline-block;
}

.quality-chip {
  font-weight: 500;
  padding: 8px 16px !important;
  border-radius: 20px !important;
  backdrop-filter: blur(10px);
  background: rgba(23, 162, 184, 0.9) !important;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(23, 162, 184, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(23, 162, 184, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(23, 162, 184, 0);
  }
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
}

.primary-btn {
  border-radius: 12px !important;
  padding: 0 32px !important;
  font-weight: 600;
  background: linear-gradient(135deg, #ffffff, #f8f9fa) !important;
  color: #0056b3 !important;
  transition: all 0.3s ease;
}

.primary-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(255, 255, 255, 0.25) !important;
}

.secondary-btn {
  border-radius: 12px !important;
  padding: 0 32px !important;
  font-weight: 500;
  border-width: 2px !important;
  transition: all 0.3s ease;
}

.secondary-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-3px);
}

.trust-indicators {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 2rem;
}

.indicator-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
}

/* Services Section */
.services-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.section-header {
  max-width: 800px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #0056b3;
  position: relative;
  display: inline-block;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #0056b3, #17a2b8);
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1.25rem;
  color: #6c757d;
  line-height: 1.6;
  max-width: 700px;
  margin: 1.5rem auto 0;
}

.service-card {
  border-radius: 20px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: white !important;
}

.service-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0056b3, #17a2b8);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.service-card:hover::before {
  transform: scaleX(1);
}

.service-card-hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
}

.service-icon-wrapper {
  display: flex;
  justify-content: center;
}

.service-icon-container {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.service-card:hover .service-icon-container {
  transform: scale(1.1) rotate(5deg);
}

.service-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 12px;
}

.service-description {
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.5;
  margin-bottom: 16px;
}

.service-features {
  margin-bottom: 16px;
}

.service-feature {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #4a5568;
  margin-bottom: 6px;
}

.service-btn {
  border-radius: 10px !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.service-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Advantages Section */
.advantages-section {
  background: white;
}

.advantage-card {
  border-radius: 16px !important;
  border-left: 4px solid;
  transition: all 0.3s ease;
  height: 100%;
  border-color: inherit;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;
}

.advantage-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d3748;
}

.advantage-description {
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.6;
}

/* Header Styles */
.header-elegant {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.98) !important;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
  z-index: 1000;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.logo-text {
  font-size: 1.75rem;
  letter-spacing: 1.5px;
  font-weight: 800;
  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logo-subtitle {
  letter-spacing: 1.2px;
  font-weight: 500;
  font-size: 0.7rem;
}

.nav-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.3px;
  margin: 0 8px !important;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px !important;
  padding: 8px 16px !important;
}

.nav-btn::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #0056b3, #17a2b8);
  transition: width 0.3s ease;
}

.nav-btn:hover::before {
  width: 80%;
}

.nav-btn:hover {
  transform: translateY(-2px);
  background: rgba(0, 86, 179, 0.05) !important;
}

.nav-btn.active-nav {
  color: #0056b3 !important;
  font-weight: 600;
}

.nav-btn.active-nav::before {
  width: 80%;
}

/* Responsive */
@media (max-width: 960px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 2.25rem;
  }

  .carousel-card-content {
    padding: 40px 20px;
  }

  .carousel-title {
    font-size: 1.8rem;
  }

  .carousel-description {
    font-size: 1.1rem;
  }

  .carousel-stats {
    flex-direction: column;
    gap: 20px;
  }

  .services-carousel {
    height: 500px;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }

  .carousel-btn {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .carousel-title {
    font-size: 1.5rem;
  }

  .carousel-description {
    font-size: 1rem;
  }

  .logo-text {
    font-size: 1.5rem;
  }

  .hero-actions {
    flex-direction: column;
  }

  .whatsapp-main-btn,
  .secondary-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
